<docs>
    Thie Vue component is used to create GPS feeds
</docs>

<template>
    <modal title="Create GPS Feed" :show.sync="showing" @cancel="closeModal" :verticallyCentered="true">
        <div>
            <loading-alert v-if="loading"></loading-alert>

            <form v-show="( !loading && !hasError )" @submit.prevent="submit()" autocomplete="off">
                <div class="t-bg-white t-rounded t-px-8 t-pt-6 t-pb-8">
                    <div class="md:t-flex md:t-items-center t-mb-6">
                        <div class="md:t-w-1/3">
                            <label class="t-block t-text-gray-500 t-font-bold md:t-text-right md:t-mb-0 t-pr-4">Type (*)</label>
                        </div>
                        <div class="md:t-w-2/3">
                            <select v-model="form.type"
                                    :class="{ 'is-invalid': errors.has('type') }"
                                    v-validate="'required'"
                                    class="t-block t-appearance-none t-w-2/3 t-bg-gray-200 t-border t-border-gray-200 t-text-gray-700 t-py-3 t-px-4 t-pr-8 t-rounded t-leading-tight focus:t-outline-none focus:t-bg-white focus:t-border-gray-500"
                                    @change="typeChanged()">
                                <option v-for="(type, index) in types"
                                        :key="index"
                                        :value="index">
                                    {{ type.label }}</option>
                            </select>
                            
                            <div v-show="errors.has('type')" class="t-text-red-700 t-text-sm">
                                Please select a type
                            </div>
                        </div>
                    </div>

                    <div class="md:t-flex md:t-items-center t-mb-6">
                        <div class="md:t-w-1/3">
                            <label class="t-block t-text-gray-500 t-font-bold md:t-text-right md:t-mb-0 t-pr-4">Name (*)</label>
                        </div>
                        <div class="md:t-w-2/3">
                            <input v-model="form.name"
                                   :class="{ 'is-invalid': errors.has('name') }"
                                   v-validate="'required'"
                                   name="name"
                                   class="t-block t-appearance-none t-w-2/3 t-bg-gray-200 t-border t-border-gray-200 t-text-gray-700 t-py-3 t-px-4 t-pr-8 t-rounded t-leading-tight focus:t-outline-none focus:t-bg-white focus:t-border-gray-500"
                                   type="text">
                            <div v-show="errors.has('name')" class="t-text-red-700 t-text-sm">
                                Please enter a name
                            </div>
                        </div>
                    </div>

                    <div v-if="!loading">
                        <hr>
                        <div v-for="input in types[form.type]['auth-validation']" :key="input.key" class="md:t-flex md:t-items-center t-mb-6">
                            <div class="md:t-w-1/3">
                                <label class="t-block t-text-gray-500 t-font-bold md:t-text-right md:t-mb-0 t-pr-4">{{ input.label }} (*)</label>
                            </div>
                            <div class="md:t-w-2/3">
                                <input v-model="form.auth[input.name]"
                                    :class="{ 'is-invalid': errors.has(input.name) }"
                                    v-validate="'required'"
                                    :name="input.name"
                                    class="t-block t-appearance-none t-w-2/3 t-bg-gray-200 t-border t-border-gray-200 t-text-gray-700 t-py-3 t-px-4 t-pr-8 t-rounded t-leading-tight focus:t-outline-none focus:t-bg-white focus:t-border-gray-500"
                                    type="text">
                                <div v-show="errors.has(input.name)" class="t-text-red-700 t-text-sm">
                                    Please enter this field
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="t-flex t-items-center t-justify-end t-pt-4">
                    <button @click="closeModal"
                            type="button"
                            class="t-bg-gray-500 hover:t-bg-gray-700 t-text-white t-font-bold t-py-2 t-px-4 t-my-4 t-rounded focus:t-outline-none focus:t-shadow-outline"
                            data-dismiss="modal">
                    Close
                    </button>
                    <button :disabled="saving" type="submit" class="t-bg-green-500 hover:t-bg-green-700 t-text-white t-font-bold t-py-2 t-px-4 t-mx-4 t-my-4 t-rounded focus:t-outline-none focus:t-shadow-outline">
                        <i v-if="saving" class="fa fa-spinner fa-spin"></i>
                        <span v-else>Add GPS feed</span>
                    </button>
                </div>
            </form>
        </div>
    </modal>
</template>

<script>
    import Modal from '../../utils/Modal_v2';
    import LoadingAlert from '../../utils/LoadingAlert';

    export default {
        name: 'gps-feeds-form',
        components: {
            Modal,
            LoadingAlert,
        },
        props: ['showing'],
        $_veeValidate: {
            validator: 'new'
        },
        data() {
            return {
                loading: true,
                saving: false,
                hasError: null,
                types: [],
                form: {
                    name: '',
                    type: null,
                    auth: {}
                }
            }
        },

        mounted() {
            this.loadTypes();
        },

        methods: {
            closeModal() {
                this.$emit('cancelled');
            },

            typeChanged() {
                // Sets the auth property as an object of auth name keys with empty values
                this.form.auth = {};

                for (var i = 0; i < this.types[this.form.type]['auth-validation'].length; i++) {
                    this.form.auth[this.types[this.form.type]['auth-validation'][i].name] = null;
                }
            },

            loadTypes() {
                api.get('/carrier/gps/gps-feeds/types')
                   .then((response) => {
                       this.types = response.data.data;
                       this.form.type = 0;
                       this.typeChanged();
                       this.loading = false;
                   }).catch((error) => {
                       this.saving = false;
                       this.$swal({
                           title: "Error!",
                           message: "Please try again",
                           type: "error"
                       })
                   });
            },

            submit() {
                this.saving = true;

                api.post('/carrier/gps/gps-feeds', {
                    name: this.form.name,
                    type: this.types[this.form.type].key,
                    authentication: this.form.auth
                }).then((response) => {
                    this.$emit('submitted');
                });
            }
		}
    }
</script>